import { PublicClientApplication } from '@azure/msal-browser';

const CONSUMER_AUTHORITY = 'https://login.microsoftonline.com/consumers';
const AUTH_SCOPES = ['OneDrive.ReadWrite'];
const POPUP_REDIRECT = window.location.origin + '/auth/redirect';

let app: PublicClientApplication | null = null;
let currentClientId: string | null = null;
let initDone = false;

async function ensureApp(clientId: string): Promise<PublicClientApplication> {
  if (app && currentClientId === clientId && initDone) {
    return app;
  }

  app = new PublicClientApplication({
    auth: {
      clientId,
      authority: CONSUMER_AUTHORITY,
      redirectUri: POPUP_REDIRECT,
    },
  });
  currentClientId = clientId;
  await app.initialize();
  await app.handleRedirectPromise().catch(() => {});

  const accounts = app.getAllAccounts();
  if (accounts.length > 0) {
    app.setActiveAccount(accounts[0]);
  }

  initDone = true;
  return app;
}

export async function getToken(clientId: string): Promise<string> {
  const msalApp = await ensureApp(clientId);

  // Try silent first
  try {
    const resp = await msalApp.acquireTokenSilent({ scopes: AUTH_SCOPES });
    return resp.accessToken;
  } catch {
    // Silent auth failed, fall through to popup
  }

  // Popup login
  const resp = await msalApp.loginPopup({
    scopes: AUTH_SCOPES,
    redirectUri: POPUP_REDIRECT,
  });
  msalApp.setActiveAccount(resp.account);

  if (resp.idToken) {
    const resp2 = await msalApp.acquireTokenSilent({
      scopes: AUTH_SCOPES,
      account: resp.account!,
    });
    return resp2.accessToken;
  }

  throw new Error('Could not acquire OneDrive token');
}
